import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'

const BASE = '/hanh-chinh/tham-du'

// Lấy danh sách người tham dự
export function layDanhSachNguoiThamDu(meetingBookingId: number) {
  try {
    return axiosApi.get(`${BASE}/${meetingBookingId}/danh-sach`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật trạng thái tham dự
export function capNhatTrangThaiThamDu(meetingBookingId: number, userId: number, status: string) {
  try {
    return axiosApi.put(
      `${BASE}/${meetingBookingId}/nguoi-dung/${userId}/cap-nhat-trang-thai?status=${encodeURIComponent(status)}`
    )
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
